<template>
  <video v-if="thumbnail" muted playsinline style="width:100%;">
    <source
      :src="
        'https://' + s3bucket + '.s3.eu-central-1.amazonaws.com/' + filename
      "
    />
  </video>
  <video v-else controls autoplay loop muted playsinline style="width:100%;">
    <source
      :src="
        'https://' + s3bucket + '.s3.eu-central-1.amazonaws.com/' + filename
      "
    />
  </video>
</template>

<script>
export default {
  props: {
    filename: {
      type: String,
      required: true
    },
    s3bucket: {
      type: String,
      required: true
    },
    thumbnail: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>
